import { render, staticRenderFns } from "./index.vue?vue&type=template&id=38d8630a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=38d8630a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38d8630a')) {
      api.createRecord('38d8630a', component.options)
    } else {
      api.reload('38d8630a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=38d8630a", function () {
      api.rerender('38d8630a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/typeManage/index.vue"
export default component.exports